import React, { Fragment } from 'react';

import { generatePreview } from '../../services/renderingClient';
import { generateFragmentObject } from '../../util/url';
import BackgroundSelection from './backgroundSelection';
import ImageLoader from '../ImageLoader';
import ImageSelection from '../imageSelection';
import SceneSelection from './sceneSelection';
import SizeSelection from './sizeSelection';
import FormatSelection from './formatSelection';
import UrlRenderer from './urlRenderer';
import ApiTab from '../ApiTab';

const colorMap = {
    width: '#41B5DC',
    height: '#14BC9C',
    scene: '#9C27B0',
    bgcolor: '#673AB7',
    format: '#E58628',
    quality: '#22917E',
    instructions_uri: '#882211',
    imageuris: '#882211',
};

export default class Rendering extends ApiTab {
    state = {
        fragmentUrl: {
            fragments: [],
            url: '',
        },
        height: '',
        width: '400',
        quality: 100,
        format: 'png',
        background: '',
        image: '',
        scene: 'https://scenes.documents.cimpress.io/v2/merchants/SceneTestGroup/scenes/f7c98062-9b5c-4d1f-a4c0-80928a6bc480/compositions/index',
    }

    componentWillMount() {
        this.updateFragment();
    }

    setVariable(variable, value) {
        this.setState({ [variable]: value }, this.updateFragment);
    }

    updateFragment = () => {
        const { scene, width, height, quality, format, background, image } = this.state;
        const url = generatePreview({ url: scene, width, height, quality, format, background, image });
        this.setState({ fragmentUrl: generateFragmentObject(url, colorMap) });
    }

    renderLeft = () => (
        <Fragment>
            <div className='color-attribute' style={{ borderColor: colorMap.imageuris }}>
                <ImageSelection {...this.valueLink('image')} />
            </div>
            <SceneSelection {...this.valueLink('scene')} color={colorMap.scene} />
            <BackgroundSelection {...this.valueLink('background')} color={colorMap.bgcolor} />
            <SizeSelection {...this.valueLink('height')} {...this.valueLink('width')} colorMap={colorMap} />
            <FormatSelection {...this.valueLink('format')} {...this.valueLink('quality')} colorMap={colorMap} />
        </Fragment>
    )

    renderTitle = () => (
        <Fragment>
            <span className='preview__title'>Explore our powerful rendering engine.</span>
            <a href='https://developer.cimpress.io/apis/graphics/rendering-service' target='_blank' rel='noopener noreferrer'> API details here.</a>
            <UrlRenderer fragmentUrl={this.state.fragmentUrl} />
        </Fragment>
    )

    renderRight = () => (
        <Fragment>
            <ImageLoader url={this.state.fragmentUrl.url} alt='rendered preview' />
            <div className='rendered-fragment__label'>Preview</div>
        </Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/rendering/index.jsx